import FileOnlyList from '@rd-web-markets/shared/dist/folders_and_files/modal/FileOnlyList';
import { projectReportAiTranscriptStatusesService } from '@rd-web-markets/shared/dist/services/claim_project_reports/project_ai_transcript_statuses.service';
import claimProjectReportService from '@rd-web-markets/shared/dist/services/project_report/claim_project_report.service';
import { AddButton, StartAiJobButton } from '@rd-web-markets/shared/dist/util/buttons';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProjectReportSlice from './ProjectReportSlice';
const AiProjectReportSliceList = _ref => {
  var _report$meeting_trans;
  let {
    handleTinyMce,
    handleSliceChange,
    handleSubmit,
    key,
    index,
    slice,
    report,
    setReport,
    pageAccess
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [lastFile, setLastFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    status,
    setStatus,
    interval,
    setInterval
  } = projectReportAiTranscriptStatusesService.useFetchStatusWithInterval({
    projectId: report.id,
    setLoading: setLoading
  });
  const createTranscript = projectReportAiTranscriptStatusesService.useCreate({
    projectId: report.id,
    setLoading,
    onSuccess: setStatus
  });
  const [,, fetchReport] = claimProjectReportService.useGet(report.claim_group_id, report.id, setLoading, setReport);
  const onFilesChanged = files => {
    if (!(files !== null && files !== void 0 && files.length)) {
      return;
    }
    const filesSortedByCreationDate = files.sort((a, b) => a.created_at > b.created_at ? -1 : 0);
    setLastFile(filesSortedByCreationDate[0]);
  };
  useEffect(() => {
    async function updateIntervalStateAndFetchReport() {
      if (['in_progress', 'not_started'].includes(status === null || status === void 0 ? void 0 : status.generation_status) && !(interval !== null && interval !== void 0 && interval.started)) {
        interval.start();
        setLoading(true);
      } else if (interval !== null && interval !== void 0 && interval.started) {
        interval.clear();
        setLoading(true);
        await fetchReport();
      } else if (!(interval !== null && interval !== void 0 && interval.started)) {
        await fetchReport();
      }
    }
    updateIntervalStateAndFetchReport();
    return () => {
      (interval === null || interval === void 0 ? void 0 : interval.started) && interval.clear();
    };
  }, [fetchReport, interval, status]);
  if ((status === null || status === void 0 ? void 0 : status.generation_status) === 'in_progress' || (status === null || status === void 0 ? void 0 : status.generation_status) === 'not_started' || loading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loader, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, status && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      color: status.generation_status === 'completed' ? 'green' : status.generation_status === 'failed' ? 'red' : 'gray'
    }
  }, status.generation_status === 'completed' ? 'check_circle' : status.generation_status === 'failed' ? 'error' : 'play_circle_outline'), /*#__PURE__*/React.createElement("span", null, t("generation_status.".concat(status.generation_status)))), lastFile && /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-5",
    style: {
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement("div", null, t('latest_transcript'), " ", lastFile.name, " ", t('from'), " ", createTimezonedDate(lastFile.created_at).toCustomLocaleDateString()), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '10px'
    }
  }), /*#__PURE__*/React.createElement(StartAiJobButton, {
    text: t('generate_ai_suggestions'),
    onClick: createTranscript
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(AddButton, {
    variant: "primary",
    onClick: () => setShowUploadFileModal(true),
    disabled: false,
    className: 'ms-auto me-3',
    text: t('file')
  })), /*#__PURE__*/React.createElement(FileOnlyList, {
    showModal: showUploadFileModal,
    setShowModal: setShowUploadFileModal,
    folderId: (_report$meeting_trans = report.meeting_transcripts_folder) === null || _report$meeting_trans === void 0 ? void 0 : _report$meeting_trans.id,
    modelId: report.id,
    modelType: 'ClaimProjectReport',
    onFilesChanged: onFilesChanged
  }), report.ai_project_report_slices.map((slice, index) => /*#__PURE__*/React.createElement(ProjectReportSlice, {
    pageAccess: pageAccess,
    handleTinyMce: handleTinyMce,
    handleSubmit: handleSubmit,
    handleSliceChange: handleSliceChange,
    key: index,
    index: index,
    slice: slice,
    isDisabled: true
  })));
};
export default AiProjectReportSliceList;